import styled from 'vue-styled-components';

import { square } from '@/styles/common.styled';

import GoogleLogo from '@svgIcons/google_round_color.svg';

export default {
    props: {
        text: undefined,
    },
    render() {
        return (
            <GoogleAuthBtn onClick={(e) => this.$emit('click', e)}>
                <GoogleLogo v-view-box />{' '}
                {this.text ||
                    this.$t('CONNECTION.google_spreadsheet_oauth_btn')}
            </GoogleAuthBtn>
        );
    },
};

const GoogleAuthBtn = styled.button`
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
    padding: 10px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: 500;
    border-radius: 2px;
    display: flex;
    align-items: center;
    & > svg {
        ${square(18)};
        margin-right: 21px;
    }

    &:active {
        background: #eee;
    }
`;
